import RouteActions from './actions';

const INITIAL_STATE = {
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  onSubmit:false,
  data:{},
  errorInternal:false,
  helperFull:null
};

function RouteReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RouteActions.BEFORE_ASSIGN:
      return { ...state,isError: false, isProcessing: true,onSubmit:true};
    case RouteActions.AFTER_ASSIGN:
      return { ...state, isProcessing: false,onSubmit:false,data:action.payload};
      case RouteActions.BEFORE_REVOKE:
        return { ...state,isError: false, isProcessing: true,onSubmit:true};
      case RouteActions.AFTER_REVOKE:
        return { ...state, isProcessing: false,onSubmit:false,data:action.payload};
    case RouteActions.RESET_LIST:
      return { ...state, isProcessing: false,form:INITIAL_STATE.form,isNewRecord:true,data:{}};
    case RouteActions.NEW_DATA:
      return { ...state, isProcessing: false,data:{}, form:INITIAL_STATE.form,isNewRecord:true};
    case RouteActions.UPDATE_DATA:
      return { ...state, isProcessing: false, data:{},isNewRecord:false};
    case RouteActions.VIEW_DATA:
      return { ...state, isProcessing: false, data:action.payload,isNewRecord:false};
    case RouteActions.RESET_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form};
    case RouteActions.DELETE_DATA:
      return { ...state, isProcessing: false, form:INITIAL_STATE.form};
    case RouteActions.ON_SUBMIT:
      return { ...state, onSubmit:true};
    case RouteActions.SHOW_DATA:
      return { ...state,  isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case RouteActions.SUCCESS_DATA:
      return { ...state, isError: false, form:INITIAL_STATE.form , onSubmit:false};
    case RouteActions.PROCESS_DATA:
      return { ...state, isProcessing: true, isError: false,isSuccess:false};
    case RouteActions.GET_HELPER:
      return { ...state, isError: false,isSuccess:false,onSubmit:false,helperFull:action.payload};  
    case RouteActions.ERROR_DATA:
      return { ...state,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case RouteActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
     
    default:
      return state;
    }
}


export default RouteReducer;
